<template>
    <div class="MHServices">
        <div class="container-fluid">
            <FullCalendar ref="calendar" :options="CalendarOptions" />

            <div class="row">
                <div class="col">
                    <b-form-checkbox v-model="IncludePersonal" name="check-button" switch @change="RefreshCalendar()">
                        Show All Outlook Items
                    </b-form-checkbox>
                </div>
                <div class="col">
                    <b-form-checkbox v-model="MonthView" name="check-button" switch @change="ChangeMonthView()">
                        Month View
                    </b-form-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <SchedulingChecklist :checklist-data="ChecklistData" />
                </div>
            </div>
            <div class="row" v-if="CheckPermission('Wraparound.EmailDispatch.AgendasMinutes')">
                <div class="col">
                    <DispatchFilesToTeam :checklist-data="ChecklistData" file-type="AGENDAS" />
                </div>
                <div class="col">
                    <DispatchFilesToTeam :checklist-data="ChecklistData" file-type="MINUTES" />
                </div>
            </div>
        </div>


        <!--CREATE NEW APPOINTMENT-->
        <b-modal ref="modal-new-appointment" size="md" title="CREATE NEW APPOINTMENT" hide-footer>
            <b-container>
                <b-form @submit="CreateNewAppointment">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Client:</label>
                                <v-select required :options="ClientEnrollmentsList" label="Label" :reduce="option => option.Id" v-model="NewAppointment.ClientSubProgramMembershipID" @input="GetAvailableLocationOptions">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               :required="!NewAppointment.ClientSubProgramMembershipID"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Starts:</label>
                                <flat-pickr v-model="NewAppointment.StartDateTime" class="form-control" required :config="DateTimeConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Ends:</label>
                                <flat-pickr v-model="NewAppointment.EndDateTime" class="form-control" required :config="DateTimeConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Appointment Type:</label>
                                <select v-model="NewAppointment.AppointmentTypeID" required class="form-control">
                                    <optgroup v-for="group in AppointmentTypeOptions" :label="group.label">
                                        <option v-for="option in group.options" :value="option.Id">{{ option.Label }}</option>
                                    </optgroup>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Format:</label>
                                <select class="form-control" required v-model="NewAppointment.Format">
                                    <option value=""></option>
                                    <option value="In-Person">In Person</option>
                                    <option value="Video">Video</option>
                                    <option value="Phone">Phone</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Location Type:</label>
                                <select class="form-control" required v-model="NewAppointment.LocationType">
                                    <option value=""></option>
                                    <option value="Home">Home</option>
                                    <option value="Office">Office</option>
                                    <option value="Field">Field</option>
                                    <option value="School">School</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Location:</label>
                                <v-select taggable :options="LocationOptions" v-model="NewAppointment.Location">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               :required="!NewAppointment.Location"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                                <!--<input type="text" class="form-control" v-model="NewAppointment.Location" required />-->
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Domains Addressed (Calendar Notes):</label>
                                <textarea class="form-control" v-model="NewAppointment.Notes" rows="4"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelNewAppointment()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                ADD
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--EDIT APPOINTMENT-->
        <b-modal ref="modal-edit-appointment" size="md" title="EDIT APPOINTMENT" hide-footer>
            <b-container>
                <b-form v-if="NewAppointment.ClientSubProgramMembership" @submit="EditAppointment">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Client: </label> <span class="bold">{{ NewAppointment.ClientSubProgramMembership.Client.Person.FullName }}</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Starts:</label>
                                <flat-pickr v-model="NewAppointment.StartDateTime" class="form-control" required :config="DateTimeConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Ends:</label>
                                <flat-pickr v-model="NewAppointment.EndDateTime" class="form-control" required :config="DateTimeConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Appointment Type:</label>
                                <select :disabled="NewAppointment.DocumentID || NewAppointment.MHDocumentID" v-model="NewAppointment.AppointmentTypeID" required class="form-control">
                                    <optgroup v-for="group in AppointmentTypeOptions" :label="group.label">
                                        <option v-for="option in group.options" :value="option.Id">{{ option.Label }}</option>
                                    </optgroup>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Format:</label>
                                <select class="form-control" required v-model="NewAppointment.Format">
                                    <option value=""></option>
                                    <option value="In-Person">In Person</option>
                                    <option value="Video">Video</option>
                                    <option value="Phone">Phone</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Location Type:</label>
                                <select class="form-control" required v-model="NewAppointment.LocationType">
                                    <option value=""></option>
                                    <option value="Home">Home</option>
                                    <option value="Office">Office</option>
                                    <option value="Field">Field</option>
                                    <option value="School">School</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Location:</label>
                                <v-select taggable :options="LocationOptions" v-model="NewAppointment.Location">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               :required="!NewAppointment.Location"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                                <!--<input type="text" class="form-control" v-model="NewAppointment.Location" required />-->
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Domains Addressed (Calendar Notes):</label>
                                <textarea class="form-control" v-model="NewAppointment.Notes" rows="4"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Appointment Status:</label>
                                <select :disabled="NewAppointment.DocumentID || NewAppointment.MHDocumentID" class="form-control" required v-model="NewAppointment.AppointmentStatus">
                                    <option value="Pending">Pending</option>
                                    <option value="Occurred">Occurred</option>
                                    <option value="Cancelled by Client">Cancelled by Client</option>
                                    <option value="Cancelled by Provider">Cancelled by Provider</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEditAppointment()">
                                CLOSE
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                UPDATE
                            </b-button>
                            <b-button v-if="!NewAppointment.DocumentID && !NewAppointment.MHDocumentID && NewAppointment.AppointmentStatus != 'Pending'" size="md" variant="warning" @click="SaveThenLockDocument()">
                                <font-awesome-icon :icon="['fa', 'lock']" /> LOCK DOCUMENT
                            </b-button>
                            <b-button v-if="NewAppointment.CurrentDocumentStatus == 'Draft'" size="md" variant="warning" @click="EditDocument(NewAppointment.DocumentID)">
                                <font-awesome-icon :icon="['fa', 'edit']" /> DOCUMENTATION
                            </b-button>
                            <b-button v-if="NewAppointment.CurrentDocumentStatus != 'Draft' && NewAppointment.CurrentDocumentStatus != 'NA'" size="md" variant="warning" @click="ViewDocument(NewAppointment.Document.PDFFileID, 'Documentation', 'Documentation.pdf')">
                                <font-awesome-icon :icon="['fa', 'eye']" /> DOCUMENTATION
                            </b-button>
                            <!--MH DOCUMENTATION-->
                            <b-button v-if="NewAppointment.CurrentMHDocumentStatus == 'Draft'" size="md" variant="primary" @click="EditDocument(NewAppointment.MHDocumentID)">
                                <font-awesome-icon :icon="['fa', 'edit']" /> MH NOTE
                            </b-button>
                            <b-button v-if="NewAppointment.CurrentMHDocumentStatus != 'Draft' && NewAppointment.CurrentMHDocumentStatus != 'NA' && NewAppointment.CurrentMHDocumentStatus != 'Incomputable'" size="md" variant="primary" @click="ViewDocument(NewAppointment.MHDocument.PDFFileID, 'MH Documentation', 'MHDocumentation.pdf')">
                                <font-awesome-icon :icon="['fa', 'eye']" /> MH NOTE
                            </b-button>


                            <b-button v-if="!NewAppointment.DocumentID && !NewAppointment.MHDocumentID" size="md" variant="danger" @click="DeleteAppointment()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>


        <DocumentEditor ref="document-editor-modal-component" v-on:draftsupdated="GetDrafts()" :editing-submitted-document="false" />
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../services/event-bus.js';

    import FullCalendar from '@fullcalendar/vue';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import timeGridPlugin from '@fullcalendar/timegrid';
    import interactionPlugin from '@fullcalendar/interaction';

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faLock } from '@fortawesome/free-solid-svg-icons';
    library.add(faLock);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    import DocumentEditor from "../../Core/RecordComponents/DocumentEditor.vue";
    import DocumentViewer from "../../Core/RecordComponents/DocumentViewer.vue";
    import DeleteIconRequest from "../../Core/ItemEditors/DeleteIconRequest.vue";

    export default {
        created() {
            EventBus.$on('drafts-updated', chartId => {
                this.RefreshCalendar();
                if (this.$refs['modal-edit-appointment'].isShow) {
                    this.ShowEditAppointment(this.NewAppointment.Id)
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('drafts-updated');
        },
        props: [
            "SubProgramId"
        ],
        data: function () {
            return {
                ChecklistData: [],
                NewAppointment: {},
                LocationOptions: [],
                IncludePersonal: false,
                AppointmentTypes: [],
                ClientEnrollmentsList: [],

                DateTimeConfig: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y h:i K',
                },

                MonthView: false
            };
        },
        methods: {
            //CALENDAR METHODS
            RefreshCalendar() {
                let calAPI = this.$refs['calendar'].getApi();
                calAPI.refetchEvents();
            },
            HandleSelect: function (arg) {
                this.ShowNewAppointment(arg.startStr, arg.endStr);
            },
            HandleEventClick: function (arg) {
                this.ShowEditAppointment(arg.event.id);
            },
            HandleEventResize: function (arg) {
                this.UpdateAppointmentTime(arg.event.id, arg.event.startStr, arg.event.endStr);
            },
            HandleEventDrop: function (arg) {
                this.UpdateAppointmentTime(arg.event.id, arg.event.startStr, arg.event.endStr);
            },
            UpdateAppointmentTime(id, newStart, newEnd) {
                this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/UpdateAppointmentTime", { Id: id, StartDateTime: newStart, EndDateTime: newEnd }, this.RefreshCalendar, this.RefreshCalendar, true);
            },
            EditDocument(documentID) {
                this.$refs['document-editor-modal-component'].ShowExistingDocumentModal(documentID);
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            //OTHER METHODS
            //data getting
            GetAvailableLocationOptions(clientSubProgramMembershipID) {
                this.LocationOptions = [];
                this.$MasterAPI.ExecuteRequest("GET", "GenMod/ClientAppointments/GetAvailableLocations", { clientSubProgramMembershipID: clientSubProgramMembershipID }, this.GetAvailableLocationOptionsSuccess, () => { }, false);
            },
            GetAvailableLocationOptionsSuccess(response) {
                this.LocationOptions = response.data.data;
            },
            //New Appointments
            ShowNewAppointment(startObj, endObj) {
                this.NewAppointment = {
                    StartDateTime: startObj,
                    EndDateTime: endObj
                }
                this.$refs['modal-new-appointment'].show();
            },
            CancelNewAppointment() {
                this.$refs['modal-new-appointment'].hide();
            },
            CreateNewAppointment(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/CreateAppointment", this.NewAppointment, this.CreateNewAppointmentSuccess, this.RefreshCalendar, true);
            },
            CreateNewAppointmentSuccess(response) {
                this.RefreshCalendar();
                this.$refs['modal-new-appointment'].hide();
                this.ShowEditAppointment(response.data.data.Id);
            },
            //Edit Appointments
            //ShowEditAppointment(appointmentID) {
            //    this.$MasterAPI.ExecuteRequest("GET", "GenMod/ClientAppointments/GetAppointment", { Id: appointmentID }, this.ShowEditAppointmentSuccess, this.RefreshCalendar, true);
            //},
            //ShowEditAppointmentSuccess(response) {
            //    this.NewAppointment = response.data.data;
            //    this.GetAvailableLocationOptions(this.NewAppointment.ClientSubProgramMembershipID)
            //    this.$refs['modal-edit-appointment'].show();
            //},
            //InviteWithEmail(email) {
            //    this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/InviteWithEmail", { AppointmentID: this.NewAppointment.Id, Email: email }, this.InviteWithEmailSuccess, this.RefreshCalendar, true);
            //},
            //InviteWithEmailSuccess(response) {
            //    this.ShowEditAppointment(this.NewAppointment.Id);
            //},
            //CancelEditAppointment() {
            //    this.$refs['modal-edit-appointment'].hide();
            //},
            //EditAppointment(e) {
            //    e.preventDefault();
            //    this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/UpdateAppointment", this.NewAppointment, this.EditAppointmentSuccess, this.RefreshCalendar, true);
            //},
            //EditAppointmentSuccess(response) {
            //    this.RefreshCalendar();
            //    this.$refs['modal-edit-appointment'].hide();
            //},
            //SaveThenLockDocument() {
            //    //validate document

            //    //Update any changes to the appointment
            //    this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/UpdateAppointment", this.NewAppointment, this.SaveThenLockDocumentSuccess, this.RefreshCalendar, true);

            //},
            //SaveThenLockDocumentSuccess(response) {
            //    this.RefreshCalendar();
            //    //Perform Lock Operation
            //    this.LockDocument();
            //},
            //LockDocument() {
            //    this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/CreateDocument", { Id: this.NewAppointment.Id }, this.LockDocumentSuccess, this.RefreshCalendar, true);
            //},
            //LockDocumentSuccess(response) {
            //    this.RefreshCalendar();
            //    this.ShowEditAppointment(this.NewAppointment.Id);
            //    if (!response.data.data.DocumentID && !response.data.data.MHDocumentID) {
            //        alert("There are no documents associated with this appointment type and appointment status, so there is no need to lock the document");
            //    }
            //},
            //DeleteAppointment() {
            //    this.$MasterAPI.ExecuteRequest("POST", "GenMod/ClientAppointments/DeleteAppointment", { Id: this.NewAppointment.Id }, this.DeleteAppointmentSuccess, this.RefreshCalendar, true);
            //},
            //DeleteAppointmentSuccess(response) {
            //    this.RefreshCalendar();
            //    this.$refs['modal-edit-appointment'].hide();
            //},
            //CheckPermission(permissionName) {
            //    return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            //},
            //formatDate(value, fmt = 'MM/D/YYYY') {
            //    return (value == null)
            //        ? ''
            //        : moment(value, 'YYYY-MM-DD').format(fmt)
            //},
            //UpdateAppointmentLabel() {
            //    let vm = this;
            //    this.$store.state.Clients.ClientEnrollmentsList.map(function (client) {
            //        if (client.DischargeDate != null)
            //            return client.label = client.ClientName + ' ' + vm.formatDate(client.ReferralDate) + ' - ' + vm.formatDate(client.DischargeDate);
            //        else {
            //            return client.label = client.ClientName;
            //        }
            //    });
            //},
            //ChangeMonthView: function () {
            //    let calAPI = this.$refs['calendar'].getApi();
            //    if (this.MonthView) {
            //        //this.MonthView = false;
            //        calAPI.changeView('timeGridWeek');
            //    } else {
            //        //this.MonthV
            //        calAPI.changeView('dayGridMonth');
            //    }
            //},
            //GetClientEnrollmentsList() {
            //    this.$MasterAPI.ExecuteRequest("GET", "GenMod/ClientAppointments/GetClientEnrollments", { this.SubProgramId }, this.GetClientEnrollmentsListSuccess, null, true);
            //},
            //GetClientEnrollmentsListSuccess(response) {
            //    this.ClientEnrollmentsList = response.data.data;
            //},
            //GetAppointmentTypeOptions() {
            //    this.$MasterAPI.ExecuteRequest("GET", "GenMod/ClientAppointments/GetAppointmentTypeOptions", { }, this.GetAppointmentTypeOptionsSuccess, null, true);
            //},
            //GetAppointmentTypeOptionsSuccess(response) {
            //    this.AppointmentTypes = response.data.data;
            //}
        },
        components: {
            FullCalendar,
            DocumentEditor,
            DocumentViewer,
            flatPickr,
            vSelect,
            DeleteIconRequest
        },
        mounted() {
            this.GetClientEnrollmentsList();
            this.GetAppointmentTypeOptions();
        },
        computed: {
            AppointmentTypeOptions: function () {
                let groups = [];
                let output = []
                this.AppointmentTypes.forEach(function (item) {
                    if (!groups.includes(item.ProgramType)) {
                        groups.push(item.ProgramType);
                    }
                });
                groups.forEach(function (item) {
                    output.push({
                        label: item,
                        options: optionsList.filter(opt => opt.ProgramType == item)
                    });
                });

                return output;
            },
            CalendarOptions: function () {
                let vm = this;
                let initialOptions = {
                    plugins: [timeGridPlugin, interactionPlugin, dayGridPlugin],
                    initialView: "timeGridWeek",
                    editable: true,
                    allDaySlot: false,
                    slotMinTime: "00:00:00",
                    slotMaxTime: "23:59:00",
                    contentHeight: 1500,
                    height: 500,
                    selectable: true,
                    allDaySlot: true,
                    select: this.HandleSelect,
                    eventClick: this.HandleEventClick,
                    eventResize: this.HandleEventResize,
                    eventDrop: this.HandleEventDrop,
                    //events: '/API/Wraparound/ClientAppointments/GetMyAppointments',
                    eventSources: [
                        {
                            url: '/API/Residential/ClientAppointments/GetMyAppointments',
                            extraParams: { IncludePersonal: this.IncludePersonal }
                        }
                    ],
                    eventSourceSuccess: function (content, xhr) {
                        vm.ChecklistData = content.data.ClientOffWeeks;
                        return content.data.Events;
                    }
                };

                return initialOptions;
            },

        },
    }
</script>

<style scoped>
</style>